import { registerValidationComponent } from './validator';
import Vue2Filters from 'vue2-filters';

export function registerPlugins(app) {
  app.use(Vue2Filters);
  registerValidationComponent(app);
}
